import * as tslib_1 from "tslib";
import RuleRow from 'owa-rules-option-common/lib/components/RuleRow';
import setSweepRule from '../actions/setSweepRule';
import store from '../store/store';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import folderStore from 'owa-folders';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { format } from 'owa-strings';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import getSweepRules from '../actions/getSweepRules';
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./SweepRulesFull.scss');
var SweepRulesFull = /** @class */ (function (_super) {
    tslib_1.__extends(SweepRulesFull, _super);
    function SweepRulesFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDescriptionText = function (sweepRule) {
            var senderSMTP = sweepRule.SweepConditions[0].SenderSmtpAddress;
            var sourceFolder = folderStore.folderTable.get(sweepRule.SweepConditions[0].SourceFolderId);
            var destinationFolder = folderStore.folderTable.get(sweepRule.SweepActions[0].DestinationFolderId);
            var keepNType = sweepRule.SweepActions[0].CleanUpType;
            var keepCount = sweepRule.SweepActions[0].KeepCount;
            var conditionString;
            var actionString;
            // If moving messages from a folder other than inbox, include source folder name in description
            if (!sourceFolder) {
                conditionString = format(strings.options_sweepRules_messagesFromIn, senderSMTP, strings.options_sweepRules_folderNotFound);
            }
            else if (sourceFolder.FolderId.Id != folderNameToId('inbox')) {
                conditionString = format(strings.options_sweepRules_messagesFromIn, senderSMTP, sourceFolder.DisplayName);
            }
            else {
                conditionString = format(strings.options_sweepRules_messagesFrom, senderSMTP);
            }
            // Generate action string. Archive and delete destination folders have specific strings
            if (destinationFolder && destinationFolder.FolderId.Id == folderNameToId('deleteditems')) {
                actionString = _this.getDeleteArchiveActionString(keepNType, keepCount, strings.options_sweepRules_delete);
            }
            else if (destinationFolder &&
                destinationFolder.FolderId.Id == folderNameToId('archive')) {
                actionString = _this.getDeleteArchiveActionString(keepNType, keepCount, strings.options_sweepRules_archive);
            }
            else {
                var destinationDisplayName = destinationFolder
                    ? destinationFolder.DisplayName
                    : strings.options_sweepRules_folderNotFound;
                if (keepNType == 1 /* Items */) {
                    actionString =
                        keepCount == 1
                            ? format(strings.options_sweepRules_keepLatestMove, destinationDisplayName)
                            : format(strings.options_sweepRules_keepNMove, keepCount, destinationDisplayName);
                }
                else {
                    actionString =
                        keepCount == 1
                            ? format(strings.options_sweepRules_keepLastDayMove, destinationDisplayName)
                            : format(strings.options_sweepRules_keepNDaysMove, keepCount, destinationDisplayName);
                }
            }
            return conditionString + actionString;
        };
        _this.getDeleteArchiveActionString = function (keepNType, keepCount, deleteArchiveString) {
            if (keepNType == 1 /* Items */) {
                return keepCount == 1
                    ? format(strings.options_sweepRules_keepLatestDeleteArchive, deleteArchiveString)
                    : format(strings.options_sweepRules_keepNDeleteArchive, keepCount, deleteArchiveString);
            }
            else {
                return keepCount == 1
                    ? format(strings.options_sweepRules_keepLastDayDeleteArchive, deleteArchiveString)
                    : format(strings.options_sweepRules_keepNDaysDeleteArchive, deleteArchiveString, keepCount);
            }
        };
        /**
         * Helper method that handles user click on toggle
         * @param shouldBeEnabled whether rule should be enabled
         * @param sweepRuleId sweep rule id
         */
        _this.onEnableDisableSweepRule = function (sweepRuleId, shouldBeEnabled) {
            var sweepOperation = shouldBeEnabled
                ? 2 /* Enable */
                : 3 /* Disable */;
            setSweepRule(sweepRuleId, sweepOperation);
        };
        /**
         * Helper method that handles user click on delete
         * @param sweepRuleId sweep rule id
         */
        _this.onRemoveSweepRule = function (sweepRuleId) {
            setSweepRule(sweepRuleId, 1 /* Delete */);
        };
        _this.isSweepRuleError = function (sweepRule) {
            // An invalid sweep rule is marked by
            // 1) a server property
            // 2) source folder no longer exists
            // 3) destination folder no longer exists
            var sourceFolder = folderStore.folderTable.get(sweepRule.SweepConditions[0].SourceFolderId);
            var destinationFolder = folderStore.folderTable.get(sweepRule.SweepActions[0].DestinationFolderId);
            return sweepRule.IsInError || !sourceFolder || !destinationFolder;
        };
        return _this;
    }
    SweepRulesFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_sweepRules_description),
            this.renderRuleListContent()));
    };
    /**
     * Creates the rule list content in sweep rules settings page
     * @return content of the sweep rules option page
     */
    SweepRulesFull.prototype.renderRuleListContent = function () {
        switch (store.getSweepRulesRequestStatus) {
            case 2 /* Complete */:
                return this.renderRuleRows();
            case 3 /* Error */:
                return this.getSweepRulesError();
            case 1 /* Pending */:
            default:
                return React.createElement(Spinner, { className: styles.loadingSpinner, type: SpinnerType.large });
        }
    };
    /**
     * Creates the rule rows in sweep rules settings page
     * @return sweep rule rows
     */
    SweepRulesFull.prototype.renderRuleRows = function () {
        var _this = this;
        var rows = [];
        var sweepRuleIds = this.props.sweepRulesListState.sweepRuleIds;
        sweepRuleIds.forEach(function (sweepRuleId) {
            var sweepRule = _this.props.sweepRulesListState.sweepRules.get(sweepRuleId);
            var isEnabled = sweepRule.IsEnabled;
            var isInError = _this.isSweepRuleError(sweepRule);
            var alertString = isInError ? strings.options_sweepRules_alertString : null;
            rows.push(React.createElement(RuleRow, { key: sweepRuleId, ruleName: sweepRule.Name, ruleDescription: _this.getDescriptionText(sweepRule), alertString: alertString, isDisabled: isInError, isChecked: isEnabled, enableDisableRule: function () {
                    _this.onEnableDisableSweepRule(sweepRuleId, !isEnabled);
                }, removeRule: function () {
                    _this.onRemoveSweepRule(sweepRuleId);
                } }));
        });
        return (React.createElement("div", { className: styles.sweepRuleRowsContainer }, rows.length > 0 ? (rows) : (React.createElement(OptionDescription, { className: styles.emptyRules }, strings.options_rules_noRules))));
    };
    /**
     * Creates error message div on get sweep rules error
     * @return error message div
     */
    SweepRulesFull.prototype.getSweepRulesError = function () {
        return (React.createElement(MessageBar, { messageBarType: MessageBarType.error, isMultiline: false, actions: React.createElement(DefaultButton, { onClick: function () {
                    getSweepRules();
                } }, strings.options_rules_tryAgain) }, strings.options_rules_loadingRulesError));
    };
    SweepRulesFull = tslib_1.__decorate([
        reactive({
            sweepRulesListState: function () { return store; },
        })
    ], SweepRulesFull);
    return SweepRulesFull;
}(React.Component));
export default SweepRulesFull;
//# sourceMappingURL=SweepRulesFull.js.map